"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.extendedUnitsForNumberSelectField = exports.unitsForNumberSelectField = void 0;
exports.unitsForNumberSelectField = [
    { label: 'minute(s)', value: 'MINUTE' },
    { label: 'hour(s)', value: 'HOUR' },
    { label: 'day(s)', value: 'DAY' },
    { label: 'week(s)', value: 'WEEK' },
];
exports.extendedUnitsForNumberSelectField = [
    { label: 'second(s)', value: 'SECOND' },
    { label: 'minute(s)', value: 'MINUTE' },
    { label: 'hour(s)', value: 'HOUR' },
    { label: 'day(s)', value: 'DAY' },
    { label: 'week(s)', value: 'WEEK' },
    { label: 'month(s)', value: 'MONTH' },
    { label: 'year(s)', value: 'YEAR' },
];
//# sourceMappingURL=utils.js.map